import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import awsConfig from './aws-config';
// Shared design tokens — loaded first so :root custom properties are
// available before any component CSS references var(--…).
import '@puro/design-tokens/tokens.css';
import './index.css';
import App from './App';

Amplify.configure(awsConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
